import React, { useEffect } from 'react'
import { observer } from 'mobx-react'
import { IonContent, IonFooter, IonHeader, IonModal } from '@ionic/react'
import { voiceServiceMobx } from '@mobxStore'
import { ActivityProductItem } from '../SearchModal/components'
import { CartBar } from '../../components'
import { getHistoryNew, setDocumentTitle } from '@utils'
import './index.scss'

interface IProps {
  reject?: () => void;
  resolve?: (product: any) => void;
  data: any;
}

const ActivityModal: React.FC<IProps> = (props) => {
  const { data } = props
  const history = getHistoryNew()
  const { getAvailableActsProducts } = voiceServiceMobx

  useEffect(() => {
    const title = document.title
    setDocumentTitle(i18n.t('menu.activityVip'))

    return () => {
      setDocumentTitle(title)
    }
  }, [])

  const handleClose = () => {
    props.reject()
  }

  const handleChooseProduct = (product) => {
    props.resolve(product)
  }

  const products = getAvailableActsProducts(data.products)

  return (
    <IonModal
      cssClass='activity-modal'
      isOpen
      showBackdrop
      swipeToClose
      backdropDismiss={false}
    >
      <IonHeader>
        {/* <div className='bpm-title'>{i18n.t('menu.activityVip')}</div> */}
        <div className='act-desc'>
          <div className='header'>
            <div className='go-back' onClick={() => handleClose()}>
              <i className='iconfont icon-BACK-12x'></i>
            </div>
            <h4>{i18n.t('menu.fullOff.partinProduct', { name: data?.activityName })}</h4>
          </div>
          {i18n.t('menu.activityExplain')}
        </div>
      </IonHeader>
      <IonContent>
        <div className='bpm-content'>
          {
            products.length ? (
              <div className='bpm-list'>
                {
                  products.map(item => {
                    return <ActivityProductItem key={item.no} product={item} onClick={handleChooseProduct} />
                  })
                }
              </div>
            ) : (
              <div className='empty-info'>
                {/* <img src={NoSearchImg} alt='' className='empty-info-pic' /> */}
                <p>{i18n.t('menu.noProductsCanDiscount')}</p>
              </div>
            )
          }
          <CartBar onClick={() => {
            if (Config.buyTogetherId) {
              history.push('/buyTogetherCart')
            } else {
              history.push('/checkout')
            }
          }}
          />
        </div>
      </IonContent>
      {/* <IonFooter className='bpm-footer'>
        <button className='default-btn' onClick={handleClose}>
          {i18n.t('common.back')}
        </button>
      </IonFooter> */}
    </IonModal>
  )
}

export default observer(ActivityModal)
